/* ==========================================================================
   Halo — JavaScript del tema
   Cajones, carrito AJAX, filtros sin recargar, variantes, vista rápida,
   favoritos, vistos recientemente, carruseles, pestañas y animaciones.
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.HaloTheme || { routes: {} };
  var routes = theme.routes;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;
  document.documentElement.classList.add('js');

  /* ---------- Utilidades ---------- */
  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  // Avisa a animations.js de que hay contenido nuevo o de que cambió el diseño
  function emit(name, root) {
    document.dispatchEvent(new CustomEvent(name, { detail: { root: root || document } }));
  }
  function escapeHTML(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function withParam(url, key, value) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + key + '=' + encodeURIComponent(value);
  }
  var store = {
    get: function (key) {
      try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
    },
    set: function (key, value) {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* almacenamiento no disponible */ }
    }
  };

  var toastTimer;
  function toast(message, isError) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    el.classList.toggle('is-error', !!isError);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 400);
    }, 2600);
  }

  /* ---------- Aparición al hacer scroll ---------- */
  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' })
    : null;

  function observeReveal(scope) {
    $$('.reveal:not(.is-in)', scope).forEach(function (el, i) {
      if (!revealObserver) { el.classList.add('is-in'); return; }
      el.style.transitionDelay = (i % 6) * 60 + 'ms';
      revealObserver.observe(el);
    });
  }

  /* ---------- Cajones y ventanas ---------- */
  var lastFocus = null;

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return false;
    if (!drawer.classList.contains('is-open')) lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var focusable = $('[data-drawer-close].icon-btn, button, a, input', drawer.querySelector('.drawer__panel'));
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 60);
    return true;
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    if (!drawer.classList.contains('facets__drawer')) drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (openDrawer(opener.getAttribute('data-drawer-open'))) e.preventDefault();
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('[data-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
  });

  /* ---------- Cabecera y botón de volver arriba ---------- */
  var header = $('[data-header]');
  var backToTop = $('[data-back-to-top]');
  function onScroll() {
    var y = window.scrollY;
    if (header) header.classList.toggle('is-scrolled', y > 10);
    if (backToTop) backToTop.hidden = y < 900;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  if (backToTop) backToTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ---------- Búsqueda predictiva ---------- */
  var searchBar = $('[data-search-bar]');
  var searchInput = $('[data-predictive-input]');
  var searchResults = $('[data-predictive-results]');
  var searchController;

  function openSearch() {
    if (!searchBar) return;
    searchBar.hidden = false;
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 30);
  }
  function closeSearch() {
    if (!searchBar || searchBar.hidden) return;
    searchBar.hidden = true;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) {
      e.preventDefault();
      if (searchBar && searchBar.hidden) openSearch(); else closeSearch();
    } else if (e.target.closest('[data-search-close]')) {
      e.preventDefault();
      closeSearch();
    }
  });

  if (searchInput && searchResults && routes.predictiveSearch) {
    searchInput.addEventListener('input', debounce(function () {
      var q = searchInput.value.trim();
      if (searchController) searchController.abort();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchController = 'AbortController' in window ? new AbortController() : null;
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, searchController ? { signal: searchController.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var content = parseHTML(html).querySelector('[data-predictive-content]');
          searchResults.innerHTML = content ? content.outerHTML : '';
        })
        .catch(function () {});
    }, 250));
  }

  /* ---------- Carrito ---------- */
  function cartSectionIds() {
    var ids = $$('[data-cart-section]').map(function (el) { return el.getAttribute('data-cart-section'); });
    if (ids.indexOf('cart-drawer') === -1 && $('#CartDrawer')) ids.push('cart-drawer');
    return ids;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      if (!sections[id]) return;
      var fresh = parseHTML(sections[id]).querySelector('[data-cart-section="' + id + '"]');
      var current = $('[data-cart-section="' + id + '"]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    });
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 300);
    });
  }

  function refreshCartCount() {
    return fetch(routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  // Animación de la foto del producto volando hasta el carrito
  function flyToCart(form) {
    return new Promise(function (resolve) {
      var target = $('.header__cart');
      var scope = form.closest('[data-product-card]') || form.closest('[data-product]');
      var img = scope && ($('.card__img', scope) || $('.product__media img', scope));
      if (!theme.flyToCart || reduceMotion || !target || !img || !img.animate) { resolve(); return; }

      var from = img.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      if (!from.width) { resolve(); return; }
      var size = Math.min(from.width, 160);
      var clone = document.createElement('img');
      clone.src = img.currentSrc || img.src;
      clone.className = 'fly-img';
      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.left = (from.left + from.width / 2 - size / 2) + 'px';
      clone.style.top = (from.top + from.height / 2 - size / 2) + 'px';
      document.body.appendChild(clone);

      var dx = to.left + to.width / 2 - (from.left + from.width / 2);
      var dy = to.top + to.height / 2 - (from.top + from.height / 2);
      var anim = clone.animate([
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.6 + 'px, ' + (dy * 0.6 - 80) + 'px) scale(.55)', opacity: 1, offset: 0.6 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.12)', opacity: 0.4 }
      ], { duration: 750, easing: 'cubic-bezier(.5,0,.3,1)' });
      anim.onfinish = function () { clone.remove(); resolve(); };
    });
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    if (button) button.classList.add('is-loading');

    var body = new FormData(form);
    var ids = cartSectionIds();
    if (ids.length) {
      body.append('sections', ids.join(','));
      body.append('sections_url', window.location.pathname);
    }

    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (button) button.classList.remove('is-loading');
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'No se pudo añadir al carrito', true);
          return;
        }
        renderCartSections(res.data.sections);
        var quickView = form.closest('#QuickView');
        return flyToCart(form).then(function () {
          if (quickView) closeDrawer(quickView);
          refreshCartCount();
          if (theme.cartType === 'drawer' && $('#CartDrawer')) {
            openDrawer('CartDrawer');
          } else {
            toast('Añadido al carrito');
          }
        });
      })
      .catch(function () {
        // Si algo falla, enviamos el formulario de la forma clásica
        form.submit();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.js-product-form');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  function changeCart(line, quantity) {
    var ids = cartSectionIds();
    $$('[data-cart-section]').forEach(function (el) { el.classList.add('is-updating'); });
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ids, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'No se pudo actualizar el carrito', true);
          return;
        }
        renderCartSections(res.data.sections);
        updateCartCount(res.data.item_count);
      })
      .catch(function () { window.location.reload(); })
      .finally(function () {
        $$('[data-cart-section]').forEach(function (el) { el.classList.remove('is-updating'); });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    changeCart(parseInt(btn.getAttribute('data-line'), 10), Math.max(0, parseInt(btn.getAttribute('data-quantity'), 10)));
  });

  /* ---------- Filtros avanzados sin recargar ---------- */
  var facetCache = {};

  function facetSection() { return $('[data-facets-section]'); }

  function buildFacetQuery(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value === '' || value === null) return;
      params.append(key, value);
    });
    return params.toString();
  }

  function renderFacets(html, sectionEl) {
    var doc = parseHTML(html);
    var openDetails = $$('details[open]', sectionEl).map(function (d) { return d.id; }).filter(Boolean);
    var closedDetails = $$('details:not([open])', sectionEl).map(function (d) { return d.id; }).filter(Boolean);
    var activeId = document.activeElement && document.activeElement.id;

    $$('[data-facet-region]', sectionEl).forEach(function (region) {
      if (!region.id) return;
      var fresh = doc.getElementById(region.id);
      if (fresh) region.innerHTML = fresh.innerHTML;
    });

    openDetails.forEach(function (id) { var d = document.getElementById(id); if (d) d.open = true; });
    closedDetails.forEach(function (id) { var d = document.getElementById(id); if (d) d.open = false; });
    if (activeId) {
      var el = document.getElementById(activeId);
      if (el && el !== document.activeElement) el.focus({ preventScroll: true });
    }
    observeReveal(sectionEl);
    syncWishlist();
    emit('halo:content', sectionEl);
  }

  function loadFacets(search, options) {
    var sectionEl = facetSection();
    if (!sectionEl) return;
    var sectionId = sectionEl.getAttribute('data-facets-section');
    var query = search.replace(/^\?/, '');
    var pageUrl = window.location.pathname + (query ? '?' + query : '');
    var fetchUrl = window.location.pathname + '?' + (query ? query + '&' : '') + 'section_id=' + encodeURIComponent(sectionId);

    sectionEl.classList.add('is-loading');
    var done = function (html) {
      facetCache[fetchUrl] = html;
      renderFacets(html, sectionEl);
      sectionEl.classList.remove('is-loading');
      if (!options || options.push !== false) history.pushState({ facets: true }, '', pageUrl);
      if (options && options.scroll) {
        var grid = $('.collection-layout', sectionEl);
        if (grid) window.scrollTo({ top: grid.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
      }
    };

    if (facetCache[fetchUrl]) { done(facetCache[fetchUrl]); return; }
    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(done)
      .catch(function () { window.location.href = pageUrl; });
  }

  var onFacetChange = debounce(function (form) { loadFacets(buildFacetQuery(form)); }, 450);
  var onPriceChange = debounce(function (form) { loadFacets(buildFacetQuery(form)); }, 900);

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form || e.target.type === 'number') return;
    onFacetChange(form);
  });
  document.addEventListener('input', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form || e.target.type !== 'number') return;
    onPriceChange(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    loadFacets(buildFacetQuery(form));
  });
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-facet-link]');
    if (!link || !facetSection() || !link.closest('[data-facets-section]')) return;
    e.preventDefault();
    var url = new URL(link.href, window.location.origin);
    loadFacets(url.search, { scroll: link.closest('.pagination') !== null });
  });
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.facets) loadFacets(window.location.search, { push: false });
  });
  if (facetSection()) history.replaceState({ facets: true }, '', window.location.href);

  /* ---------- Producto: variantes, cantidad y galería ---------- */
  function initProduct(productEl) {
    if (!productEl || productEl.hasAttribute('data-product-ready')) return;
    productEl.setAttribute('data-product-ready', '');

    var jsonEl = $('[data-product-json]', productEl);
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var form = $('.product__form', productEl);
    var idInput = $('[data-variant-id]', productEl);
    var addBtn = $('[data-add-button]', productEl);
    var addText = $('[data-add-text]', productEl);
    var priceEl = $('[data-product-price]', productEl);
    var stickyPrice = $('[data-sticky-price]', productEl);
    var gallery = $('[data-gallery]', productEl);
    var sectionId = productEl.getAttribute('data-section-id');
    var productUrl = productEl.getAttribute('data-product-url') || window.location.pathname;
    var isQuickView = productEl.hasAttribute('data-quick-view-product');

    function selectedOptions() {
      var picked = [];
      $$('[data-variant-picker] fieldset', productEl).forEach(function (fs, i) {
        var checked = $('input:checked', fs);
        picked[i] = checked ? checked.value : null;
        var label = $('[data-option-label="' + i + '"]', productEl);
        if (label && checked) label.textContent = checked.value;
      });
      return picked;
    }

    function scrollToMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var slide = $('[data-media-id="' + mediaId + '"]', gallery);
      if (!slide) return;
      if (!isQuickView && window.matchMedia('(min-width: 990px)').matches) {
        gallery.insertBefore(slide, gallery.firstElementChild);
      } else {
        gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    function onVariantChange() {
      var picked = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === picked[i]; });
      });

      if (!variant) {
        addBtn.disabled = true;
        addText.textContent = 'No disponible';
        return;
      }

      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addText.textContent = variant.available ? 'Añadir al carrito' : 'Agotado';
      if (variant.featured_media) scrollToMedia(variant.featured_media.id);

      if (!isQuickView) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      // El precio se pide al servidor para que salga con el formato de tu tienda
      if (priceEl && sectionId) {
        fetch(withParam(withParam(productUrl, 'variant', variant.id), 'section_id', sectionId))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var fresh = parseHTML(html).querySelector('[data-product-price]');
            if (!fresh) return;
            priceEl.innerHTML = fresh.innerHTML;
            if (stickyPrice) stickyPrice.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      }
    }

    if (form) form.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-option-index')) onVariantChange();
    });

    var qty = $('[data-qty-input]', productEl);
    productEl.addEventListener('click', function (e) {
      if (!qty) return;
      if (e.target.closest('[data-qty-minus]')) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      if (e.target.closest('[data-qty-plus]')) qty.value = (parseInt(qty.value, 10) || 1) + 1;
    });

    var dots = $$('.product__dots span', productEl);
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', debounce(function () {
        var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }, 60), { passive: true });
    }

    // Zoom de las fotos (solo con ratón)
    if (canHover) {
      $$('.product__media.is-zoomable', productEl).forEach(function (media) {
        var img = $('img', media);
        if (!img) return;
        media.addEventListener('click', function () { media.classList.toggle('is-zoomed'); });
        media.addEventListener('mousemove', function (e) {
          if (!media.classList.contains('is-zoomed')) return;
          var r = media.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        media.addEventListener('mouseleave', function () { media.classList.remove('is-zoomed'); });
      });
    }

    // Barra fija de compra
    var sticky = $('[data-sticky-buy]', productEl);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var stickyBtn = $('[data-sticky-add]', sticky);
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        if (backToTop) backToTop.classList.toggle('is-raised', show);
      }).observe(addBtn);

      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        if (addBtn.disabled) {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          toast('Elige una opción disponible', true);
          return;
        }
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }
  }

  /* ---------- Vista rápida ---------- */
  var quickCache = {};
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-quick-view');
    var content = $('[data-quick-view-content]');
    if (!content) { window.location.href = url; return; }

    content.innerHTML = '<div class="modal__loading" role="status" aria-label="Cargando"></div>';
    openDrawer('QuickView');

    var show = function (html) {
      quickCache[url] = html;
      var fresh = parseHTML(html).querySelector('[data-quick-view-product]');
      if (!fresh) { window.location.href = url; return; }
      content.innerHTML = '';
      content.appendChild(document.importNode(fresh, true));
      initProduct($('[data-quick-view-product]', content));
      syncWishlist();
      if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
    };

    if (quickCache[url]) { show(quickCache[url]); return; }
    fetch(withParam(url, 'section_id', 'quick-view'))
      .then(function (r) { return r.text(); })
      .then(show)
      .catch(function () { window.location.href = url; });
  });

  /* ---------- Favoritos ---------- */
  var WISH_KEY = 'halo:wishlist';

  function renderMiniItem(item, removeAttr) {
    return '<li class="mini-item">' +
      '<a class="mini-item__media" href="' + escapeHTML(item.url) + '">' +
        (item.image ? '<img src="' + escapeHTML(item.image) + '" alt="" loading="lazy" width="150" height="188">' : '') +
      '</a>' +
      '<div><a class="mini-item__title" href="' + escapeHTML(item.url) + '">' + escapeHTML(item.title) + '</a>' +
        '<span class="mini-item__price">' + escapeHTML(item.price) + '</span></div>' +
      '<button type="button" class="icon-btn" ' + removeAttr + '="' + escapeHTML(item.handle) + '" aria-label="Quitar ' + escapeHTML(item.title) + '">' +
        '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button></li>';
  }

  function syncWishlist() {
    if (!theme.wishlist) return;
    var items = store.get(WISH_KEY);
    var handles = items.map(function (i) { return i.handle; });

    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var on = handles.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach(function (el) {
      el.textContent = items.length;
      el.classList.toggle('is-empty', items.length === 0);
    });
    var list = $('[data-wishlist-list]');
    if (list) list.innerHTML = items.map(function (item) { return renderMiniItem(item, 'data-wishlist-remove'); }).join('');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-wishlist-toggle]');
    var remove = e.target.closest('[data-wishlist-remove]');
    if (!toggle && !remove) return;
    e.preventDefault();

    var items = store.get(WISH_KEY);
    if (remove) {
      var h = remove.getAttribute('data-wishlist-remove');
      items = items.filter(function (i) { return i.handle !== h; });
    } else {
      var handle = toggle.getAttribute('data-handle');
      var exists = items.some(function (i) { return i.handle === handle; });
      if (exists) {
        items = items.filter(function (i) { return i.handle !== handle; });
        toast('Quitado de favoritos');
      } else {
        items.unshift({
          handle: handle,
          title: toggle.getAttribute('data-title'),
          url: toggle.getAttribute('data-url'),
          image: toggle.getAttribute('data-image'),
          price: toggle.getAttribute('data-price')
        });
        toast('Guardado en favoritos');
        toggle.classList.remove('is-pop');
        void toggle.offsetWidth;
        toggle.classList.add('is-pop');
      }
    }
    store.set(WISH_KEY, items.slice(0, 60));
    syncWishlist();
    $$('[data-wishlist-count]').forEach(function (el) {
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 300);
    });
  });

  /* ---------- Vistos recientemente ---------- */
  var RECENT_KEY = 'halo:recent';
  var currentProduct = $('[data-recent-product]');
  if (currentProduct) {
    try {
      var data = JSON.parse(currentProduct.textContent);
      var recent = store.get(RECENT_KEY).filter(function (i) { return i.handle !== data.handle; });
      recent.unshift(data);
      store.set(RECENT_KEY, recent.slice(0, 16));
    } catch (e) { /* datos no válidos */ }
  }

  function renderRecent() {
    $$('[data-recently-viewed]').forEach(function (section) {
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 8;
      var exclude = section.getAttribute('data-exclude');
      var items = store.get(RECENT_KEY).filter(function (i) { return i.handle !== exclude; }).slice(0, limit);
      var list = $('[data-recent-list]', section);
      var wasHidden = section.hidden;
      section.hidden = items.length === 0;
      if (wasHidden !== section.hidden) emit('halo:layout', section);
      if (!list) return;
      list.innerHTML = items.map(function (item) {
        return '<li><a class="recent-card" href="' + escapeHTML(item.url) + '">' +
          '<span class="recent-card__media">' + (item.image ? '<img src="' + escapeHTML(item.image) + '" alt="" loading="lazy" width="400" height="500">' : '') + '</span>' +
          '<span class="recent-card__title">' + escapeHTML(item.title) + '</span>' +
          '<span class="recent-card__price">' + escapeHTML(item.price) + '</span></a></li>';
      }).join('');
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-recent-clear]')) return;
    store.set(RECENT_KEY, []);
    renderRecent();
  });

  /* ---------- Carruseles (flechas y arrastrar con el ratón) ---------- */
  function visibleCarousel(scope) {
    return $$('[data-carousel]', scope).filter(function (c) { return c.offsetParent !== null; })[0];
  }

  function updateCarouselNav(scope) {
    var carousel = visibleCarousel(scope);
    var prev = $('[data-carousel-prev]', scope);
    var next = $('[data-carousel-next]', scope);
    if (!carousel || !prev || !next) return;
    var max = carousel.scrollWidth - carousel.clientWidth - 4;
    prev.disabled = carousel.scrollLeft <= 4;
    next.disabled = carousel.scrollLeft >= max;
  }

  function carouselScope(el) { return el.closest('.shopify-section') || el.parentElement; }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var scope = carouselScope(btn);
    var carousel = visibleCarousel(scope);
    if (!carousel) return;
    var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    carousel.scrollBy({ left: dir * carousel.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (carousel) {
      if (carousel.hasAttribute('data-carousel-ready')) return;
      carousel.setAttribute('data-carousel-ready', '');
      var scope = carouselScope(carousel);
      carousel.addEventListener('scroll', debounce(function () { updateCarouselNav(scope); }, 80), { passive: true });
      updateCarouselNav(scope);

      // Arrastrar con el ratón en ordenador
      var startX = 0, startScroll = 0, dragging = false, moved = false;
      carousel.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true; moved = false;
        startX = e.clientX; startScroll = carousel.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) { moved = true; carousel.classList.add('is-dragging'); }
        if (moved) carousel.scrollLeft = startScroll - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        setTimeout(function () { carousel.classList.remove('is-dragging'); }, 0);
      });
      carousel.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      carousel.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- Pestañas ---------- */
  function selectTab(tab) {
    var list = tab.closest('[role="tablist"]');
    var root = tab.closest('[data-tabs]');
    if (!list || !root) return;
    $$('[role="tab"]', list).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    updateCarouselNav(carouselScope(root));
    emit('halo:layout', root);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tabs] [role="tab"]');
    if (tab) selectTab(tab);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('[data-tabs] [role="tab"]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = $$('[role="tab"]', tab.closest('[role="tablist"]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(i + tabs.length) % tabs.length];
    next.focus();
    selectTab(next);
  });

  /* ---------- Portada: productos flotantes y botón magnético ---------- */
  function initHero(root) {
    if (reduceMotion || !canHover) return;
    $$('[data-hero]', root).forEach(function (hero) {
      var cards = $$('[data-depth]', hero);
      var frame;
      hero.addEventListener('mousemove', function (e) {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          var r = hero.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          cards.forEach(function (card) {
            var d = parseFloat(card.getAttribute('data-depth')) || 10;
            card.style.transform = 'translate3d(' + (-x * d * 2) + 'px,' + (-y * d * 2) + 'px,0)';
          });
        });
      });
      hero.addEventListener('mouseleave', function () { cards.forEach(function (c) { c.style.transform = ''; }); });
    });
    $$('[data-magnet]', root).forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.2 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.3 + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Cuenta atrás (hora de España) ---------- */
  function madridDate(str) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
    if (!m) return null;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Madrid', hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
      }).formatToParts(new Date(guess)).forEach(function (p) { parts[p.type] = p.value; });
      var asMadrid = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute);
      return new Date(guess - (asMadrid - guess));
    } catch (e) {
      return new Date(guess);
    }
  }

  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      var target = madridDate(el.getAttribute('data-countdown'));
      if (!target) return;
      var clock = $('[data-countdown-clock]', el);
      var done = $('[data-countdown-done]', el);
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var diff = Math.max(0, target.getTime() - Date.now());
        var s = Math.floor(diff / 1000);
        $('[data-cd="d"]', el).textContent = pad(Math.floor(s / 86400));
        $('[data-cd="h"]', el).textContent = pad(Math.floor(s % 86400 / 3600));
        $('[data-cd="m"]', el).textContent = pad(Math.floor(s % 3600 / 60));
        $('[data-cd="s"]', el).textContent = pad(s % 60);
        if (diff === 0) {
          if (clock) clock.hidden = true;
          if (done) done.hidden = false;
          return false;
        }
        return true;
      };
      if (tick()) {
        var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
      }
    });
  }

  /* ---------- Compartir ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-share-url') || window.location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast('Enlace copiado'); });
    }
  });

  /* ---------- Productos relacionados ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = parseHTML(html).querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          observeReveal(el);
          syncWishlist();
          emit('halo:content', el);
        }
      })
      .catch(function () {});
  });

  /* ---------- Arranque ---------- */
  function initAll(root) {
    observeReveal(root);
    initCarousels(root);
    initHero(root);
    initCountdowns(root);
    $$('[data-product]', root).forEach(initProduct);
  }
  initAll(document);
  syncWishlist();
  renderRecent();

  // El editor de temas recarga secciones: volvemos a activarlas
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    syncWishlist();
    renderRecent();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest('[role="tab"]');
    if (tab) selectTab(tab);
  });
})();

/* ==========================================================================
   Halo — portada de oferta: códigos, packs, "ver más", menú de secciones,
   colores de las tarjetas y barra de progreso del carrusel.
   ========================================================================== */
(function () {
  'use strict';
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  /* Altura de la cabecera fija (para que el menú de secciones quede justo debajo) */
  function setHeaderHeight() {
    var section = document.querySelector('.section-header');
    var sticky = section && section.querySelector('.header--sticky');
    var h = sticky ? section.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--header-h', Math.round(h) + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);

  /* Copiar código de descuento */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-copy-code]');
    if (!chip) return;
    e.preventDefault();
    var code = chip.getAttribute('data-copy-code');
    var done = function () {
      chip.classList.add('is-copied');
      setTimeout(function () { chip.classList.remove('is-copied'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var tmp = document.createElement('input');
      tmp.value = code; document.body.appendChild(tmp); tmp.select();
      try { document.execCommand('copy'); } catch (err) { /* sin portapapeles */ }
      tmp.remove(); done();
    }
  });

  /* Oferta destacada: cambiar de pack */
  function goOffer(root, index) {
    var panes = $$('.offer__pane', root);
    if (index < 0 || index >= panes.length) return;
    $$('[data-offer-pane]', root).forEach(function (el) {
      var on = parseInt(el.getAttribute('data-offer-pane'), 10) === index;
      el.classList.toggle('is-active', on);
      if (el.classList.contains('offer__pane')) el.hidden = !on;
      else el.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    $$('[data-offer-go]', root).forEach(function (tab) {
      var on = parseInt(tab.getAttribute('data-offer-go'), 10) === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('[data-offer-select]', root).forEach(function (select) { select.value = String(index); });
    root.setAttribute('data-offer-index', index);
  }
  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-offer]');
    if (!root) return;
    var tab = e.target.closest('[data-offer-go]');
    var step = e.target.closest('[data-offer-step]');
    if (tab) goOffer(root, parseInt(tab.getAttribute('data-offer-go'), 10));
    if (step) {
      var current = parseInt(root.getAttribute('data-offer-index') || '0', 10);
      goOffer(root, current + parseInt(step.getAttribute('data-offer-step'), 10));
    }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-offer-select]')) return;
    goOffer(e.target.closest('[data-offer]'), parseInt(e.target.value, 10));
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-offer]');
    if (!root) return;
    var pane = e.target.closest('[data-offer-pane]');
    if (pane) goOffer(root, parseInt(pane.getAttribute('data-offer-pane'), 10));
  });

  /* Escaparate: ver más / ocultar */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-showcase-toggle]');
    if (!btn) return;
    var root = btn.closest('[data-showcase]');
    var open = !root.classList.contains('is-expanded');
    root.classList.toggle('is-expanded', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.querySelector('[data-label-more]').hidden = open;
    btn.querySelector('[data-label-less]').hidden = !open;
    if (!open) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Colores en las tarjetas: cambian la foto */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.card__swatch');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('[data-product-card]');
    $$('.card__swatch', card).forEach(function (s) {
      s.classList.toggle('is-active', s === sw);
      s.setAttribute('aria-checked', s === sw ? 'true' : 'false');
    });
    var src = sw.getAttribute('data-swatch-img');
    var img = card && card.querySelector('.card__img:not(.card__img--alt)');
    if (src && img) { img.removeAttribute('srcset'); img.src = src; }
  });
  function paintSwatches(root) {
    $$('[data-swatch-bg]', root).forEach(function (s) { s.style.backgroundImage = 'url(' + s.getAttribute('data-swatch-bg') + ')'; });
  }

  /* Menú de secciones: enlace activo según el scroll */
  function syncJumpNav() {
    $$('[data-jump-nav]').forEach(function (nav) {
      var links = $$('[data-jump-link]', nav);
      if (!links.length) return;
      var offset = nav.getBoundingClientRect().bottom + 40;
      var current = links[0];
      links.forEach(function (link) {
        var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (target && target.getBoundingClientRect().top < offset) current = link;
      });
      links.forEach(function (link) { link.classList.toggle('is-active', link === current); });
    });
  }
  var jumpFrame;
  window.addEventListener('scroll', function () {
    cancelAnimationFrame(jumpFrame);
    jumpFrame = requestAnimationFrame(syncJumpNav);
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-jump-link]');
    if (!link) return;
    var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', link.hash);
  });

  /* Carrusel de opiniones: barra de progreso */
  function initProgress(root) {
    $$('[data-progress-carousel]', root).forEach(function (track) {
      var section = track.closest('.shopify-section') || track.parentElement;
      var thumb = section.querySelector('[data-progress-thumb]');
      if (!thumb) return;
      var update = function () {
        var max = track.scrollWidth - track.clientWidth;
        var bar = thumb.parentElement.clientWidth;
        var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        var w = Math.max(0.12, Math.min(1, ratio));
        thumb.style.width = (w * 100) + '%';
        thumb.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * bar * (1 - w) : 0) + 'px)';
        thumb.parentElement.hidden = max <= 4;
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(root) {
    paintSwatches(root);
    initProgress(root);
    syncJumpNav();
    setHeaderHeight();
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
